import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { GET_PUBLIC_INBOX_MESSAGES_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import type { GetInboxMessagesRequestPayload, GetInboxMessagesResult } from '../types/getInboxMessages.types';

export const PUBLIC_INBOX_MESSAGES_TAGS = 'getPublicInboxMessages';

export const getPublicInboxMessages = (builder: BuilderType) =>
  builder.query<GetInboxMessagesResult, GetInboxMessagesRequestPayload>({
    merge: (currentCacheData, responseData, { arg }) => {
      if (responseData.MessageList && arg.isLoadMore) {
        currentCacheData.MessageList.push(...responseData.MessageList);
      }
      currentCacheData.HasMoreRecords = responseData.HasMoreRecords;
      currentCacheData.Offset = responseData.Offset;
    },
    providesTags: [PUBLIC_INBOX_MESSAGES_TAGS],
    query: (data) => ({
      data: {
        ...data,
        isLoadMore: undefined,
      },
      method: 'POST',
      url: GET_PUBLIC_INBOX_MESSAGES_URL,
    }),
    serializeQueryArgs: ({ queryArgs }) => ({
      ...queryArgs,
      isLoadMore: undefined,
      Offset: undefined,
    }),
    transformResponse: (response: GenericApiResponse<GetInboxMessagesResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
